import { AccountClass } from "@common/constants/domains/accounting/accountsv2";
import { backendClient, unwrapResponse } from "./backendClient";

export async function getChartOfAccountsCsv(
    entityId: number,
    availableClassifications?: AccountClass[],
): Promise<ArrayBuffer> {
    return unwrapResponse(
        await backendClient.get(`/${entityId}/chart-of-accounts/csv`, {
            params: { availableClassifications },
            responseType: "arraybuffer",
        }),
    );
}

export async function getChartOfAccountsXlsx(
    entityId: number,
    availableClassifications?: AccountClass[],
): Promise<ArrayBuffer> {
    return unwrapResponse(
        await backendClient.get(`/${entityId}/chart-of-accounts/xlsx`, {
            params: { availableClassifications },
            responseType: "arraybuffer",
        }),
    );
}
